import React from "react";
import {
  FaDesktop,
  FaLaptopCode,
  FaCode,
  FaServer,
  FaDatabase,
  FaCogs,
  FaMobileAlt,
  FaCloud,
  FaSearch,
  FaChartLine,
  FaNetworkWired,
  FaRobot,
  FaHeadset,
  FaWallet,
  FaTasks,
  FaBox,
} from "react-icons/fa";

const DomainAndIndustry = () => {
  const domains = [
    {
      icon: <FaDesktop className="text-blue-500 text-3xl" />,
      title: "Frontend Developer",
      description: "Browse 27+ Mentors",
    },
    {
      icon: <FaLaptopCode className="text-green-500 text-3xl" />,
      title: "Backend Developer",
      description: "Browse 120+ Mentors",
    },
    {
      icon: <FaCode className="text-purple-500 text-3xl" />,
      title: "FullStack Developer",
      description: "Browse 22+ Mentors",
    },
    {
      icon: <FaServer className="text-red-500 text-3xl" />,
      title: "DevOps/SRE",
      description: "Browse 22+ Mentors",
    },
    {
      icon: <FaDatabase className="text-teal-500 text-3xl" />,
      title: "Data Analyst",
      description: "Browse 17+ Mentors",
    },
    {
      icon: <FaCogs className="text-yellow-500 text-3xl" />,
      title: "Data Scientist",
      description: "Browse 48+ Mentors",
    },
    {
      icon: <FaMobileAlt className="text-indigo-500 text-3xl" />,
      title: "Data Engineer",
      description: "Browse 21+ Mentors",
    },
    {
      icon: <FaCloud className="text-cyan-500 text-3xl" />,
      title: "AI/ML",
      description: "Browse 48+ Mentors",
    },
    {
      icon: <FaSearch className="text-gray-600 text-3xl" />,
      title: "Marketing",
      description: "Browse 13+ Mentors",
    },
    {
      icon: <FaChartLine className="text-orange-500 text-3xl" />,
      title: "Sales",
      description: "Browse 10+ Mentors",
    },
    {
      icon: <FaCogs className="text-yellow-600 text-3xl" />,
      title: "Business Analyst",
      description: "Browse 27+ Mentors",
    },
    {
      icon: <FaNetworkWired className="text-blue-600 text-3xl" />,
      title: "Finance",
      description: "Browse 6+ Mentors",
    },
    {
      icon: <FaRobot className="text-pink-500 text-3xl" />,
      title: "Product Manager",
      description: "Browse 32+ Mentors",
    },
    {
      icon: <FaTasks className="text-green-600 text-3xl" />,
      title: "Project Manager",
      description: "Browse 11+ Mentors",
    },
    {
      icon: <FaHeadset className="text-red-600 text-3xl" />,
      title: "Customer Support",
      description: "Browse 10+ Mentors",
    },
    {
      icon: <FaBox className="text-purple-600 text-3xl" />,
      title: "Program Manager",
      description: "Browse 11+ Mentors",
    },
  ];

  return (
    <div className="bg-white min-h-screen px-4 p-2">
      <h1 className="text-center text-3xl font-semibold text-black mt-12">
        Domain & Industry
      </h1>
      <div className="overflow-x-auto mx-auto max-w-screen-xl mt-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-[2px] p-2">
          {domains.map((domain, index) => (
            <div
              key={index}
              className="flex items-center space-x-4 p-4 rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl hover:shadow-gray-500/50 cursor-pointer"
              style={{ transitionDuration: "0.5s" }}
            >
              {domain.icon}
              <div>
                <p className="text-black font-semibold">{domain.title}</p>
                <p className="text-gray-500">{domain.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DomainAndIndustry;
